export type PersonalityOverrideValues = {
  mbti_type?: string | null;
  enneagram_type?: string | null;
  big_five_scores?: unknown;
  integral_level?: string | null;
  holland_code?: string | null;
  alignment?: string | null;
  socionics_type?: string | null;
  attachment_style?: string | null;
  disc_profile?: string | null;
  sloan_type?: string | null;
} | null | undefined;

const OVERRIDE_COLUMN_BY_FIELD = {
  mbti: 'mbti_type',
  enneagram: 'enneagram_type',
  bigFive: 'big_five_scores',
  integralLevel: 'integral_level',
  hollandCode: 'holland_code',
  alignment: 'alignment',
  socionics: 'socionics_type',
  attachmentStyle: 'attachment_style',
  disc: 'disc_profile',
  sloan: 'sloan_type',
} as const;

export type PersonalityOverrideField = keyof typeof OVERRIDE_COLUMN_BY_FIELD;

/** A row only pins the framework columns that actually contain a value. */
export function hasPersonalityOverride(
  override: PersonalityOverrideValues,
  field: PersonalityOverrideField,
): boolean {
  if (!override) return false;
  const value = override[OVERRIDE_COLUMN_BY_FIELD[field]];
  if (typeof value === 'string') return value.trim().length > 0;
  return value !== null && value !== undefined;
}

/** Canonical evidence is fresh only when its source is at least as new as the assessment. */
export function isCanonicalEvidenceFresh(
  derivedFromAt: string | null | undefined,
  assessmentAt: string | null | undefined,
): boolean {
  const derived = new Date(derivedFromAt || 0).getTime();
  const assessment = new Date(assessmentAt || 0).getTime();
  return Number.isFinite(derived) && derived > 0 && derived >= assessment;
}